import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageTitleFallback: {
		defaultMessage: 'Edit dashboard',
		id: 'dashboard-edit.page-title-fallback',
		description:
			"Page title fallback of an editable Jira Dashboard page. This title is displayed when it has failed to retrieve the dashboard's name. ",
	},
	pageTitle: {
		defaultMessage: 'Edit - {dashboardName}',
		id: 'dashboard-edit.page-title',
		description:
			'Page title of an editable Jira Dashboard page. dashboardName is the name of the current dashboard.',
	},
	editingInfo: {
		defaultMessage:
			'You are currently editing your dashboard. Changes will be saved automatically.',
		id: 'dashboard-edit.editing-info',
		description:
			'An information section message to be displayed to the user whenever they are in edit mode.',
	},
});
